<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    office_channel () {
      return this.$store.getters.office_channel
    }
  },
  methods: {
    getOffice_channel (id) {
      this.$store.dispatch('getOffice_channel', id)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getOffice_channel(to.params.id)
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Office_channel.vue?01539428